export const CParentsLastTransactionsLength = 3 as const;

export const CParentLastTransactionIcon = {
    SHOPPING_BAG: 'shopping_bag.svg',
    NONE: '',
} as const